import { render } from "./opportunity-form.vue?vue&type=template&id=dbfcd6a2&scoped=true&ts=true"
import script from "./opportunity-form.vue?vue&type=script&lang=ts"
export * from "./opportunity-form.vue?vue&type=script&lang=ts"

import "./opportunity-form.vue?vue&type=style&index=0&id=dbfcd6a2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbfcd6a2"]])

export default __exports__